var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUserAltVet = function SvgUserAltVet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M45.8984 21.5C45.8984 24.17 45.1067 26.7801 43.6233 29.0002C42.1399 31.2203 40.0315 32.9506 37.5647 33.9724C35.0979 34.9942 32.3835 35.2615 29.7647 34.7406C27.146 34.2197 24.7405 32.934 22.8525 31.0459C20.9645 29.1579 19.6787 26.7525 19.1578 24.1337C18.6369 21.515 18.9043 18.8006 19.9261 16.3338C20.9479 13.867 22.6782 11.7586 24.8982 10.2752C27.1183 8.79176 29.7284 8 32.3984 8C35.9789 8 39.4126 9.42232 41.9444 11.9541C44.4761 14.4858 45.8984 17.9196 45.8984 21.5Z",
    fill: "#FF7E51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M44.3984 38H39.2328C37.0899 38.9881 34.7582 39.4998 32.3984 39.4998C30.0387 39.4998 27.707 38.9881 25.5641 38H20.3984C17.2158 38 14.1636 39.2643 11.9132 41.5147C9.66272 43.7652 8.39844 46.8174 8.39844 50L8.39844 51.5C8.39844 52.6935 8.87254 53.8381 9.71646 54.682C10.5604 55.5259 11.705 56 12.8984 56H51.8984C53.0919 56 54.2365 55.5259 55.0804 54.682C55.9243 53.8381 56.3984 52.6935 56.3984 51.5V50C56.3984 46.8174 55.1342 43.7652 52.8837 41.5147C50.6333 39.2643 47.581 38 44.3984 38Z",
    fill: "#FF7E51"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserAltVet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-alt-vet.35c13bc5.svg";
export { ForwardRef as ReactComponent };